var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.wasClick
    ? _c(
        _setup.Modal,
        {
          attrs: {
            title: "",
            "wrapper-class": "animate__animated",
            "modal-class": "room-modal",
            "in-class": "animate__zoomIn hideScroll",
            "out-class": "animate__zoomOut hideScroll",
          },
          model: {
            value: _setup.isModalShown,
            callback: function ($$v) {
              _setup.isModalShown = $$v
            },
            expression: "isModalShown",
          },
        },
        [
          _c(
            "div",
            { staticClass: "room-modal__header room-modal-header" },
            [
              _c(
                _setup.ModalTitle,
                {
                  on: {
                    close: function ($event) {
                      _setup.isModalShown = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_setup.props.CabinSet.name) +
                      _vm._s(
                        _setup.props.CabinSet.decks.length
                          ? ", " +
                              _setup.props.CabinSet.decks[0].name?.toLowerCase()
                          : ""
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "room-modal__content" }, [
            _c(
              "div",
              { staticClass: "room-modal__description room-modal-description" },
              [
                _c("div", { staticClass: "room-modal-description__header" }, [
                  _c("p", { staticClass: "room-modal-description__name" }, [
                    _vm._v("Каюта " + _vm._s(_setup.props.Cabin.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "room-modal-description__status",
                      class: { _booked: _setup.isBooked() },
                    },
                    [_vm._v(_vm._s(_setup.isBooked() ? "Выбрана" : "Свободна"))]
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.MySlider, {
                  staticClass: "room-modal-description__slider",
                  attrs: {
                    slideRatio: 200 / 300,
                    convertCdn: true,
                    slides: _setup.props.CabinSet.photos,
                    srcKey: "src",
                    idKey: "key",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "room-modal-description__points" }, [
                  _c(
                    "div",
                    { staticClass: "room-modal-description__point-element" },
                    [
                      _c(_setup.vRooms, {
                        staticClass: "boat-navigation__icon",
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_setup.accText))]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.InsertHtml, {
                  staticClass: "room-modal-description__info",
                  attrs: {
                    html: _setup.props.CabinSet.description,
                    link: "pdf",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "room-modal__order room-modal-order" }, [
              _c("div", { staticClass: "room-modal-order__info" }, [
                _c("div", { staticClass: "room-modal-order__title" }, [
                  _vm._v("Туристы"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "room-modal-order__text" }, [
                  _vm._v(
                    "\n                    Выберите размещение в каюте\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _setup.occupation
                ? _c(
                    "div",
                    { staticClass: "room-modal-order__tourists" },
                    [
                      _vm._l(_setup.occupation.list, function (opt) {
                        return _c(
                          "label",
                          { key: opt.adultChild, staticClass: "custom-radio" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _setup.occrec,
                                  expression: "occrec",
                                },
                              ],
                              attrs: { type: "radio", name: "occupation_list" },
                              domProps: {
                                value: opt.adultChild,
                                checked: _vm._q(_setup.occrec, opt.adultChild),
                              },
                              on: {
                                change: function ($event) {
                                  _setup.occrec = opt.adultChild
                                },
                              },
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_setup.vzros(opt.adult)) +
                                "\n                    "
                            ),
                            opt.child
                              ? _c(
                                  "span",
                                  [
                                    _vm._v(
                                      "\n                        + " +
                                        _vm._s(_setup.rebenok(opt.child)) +
                                        "\n                        ("
                                    ),
                                    _c(_setup.SinceTill, {
                                      attrs: {
                                        agesLine: _setup.occupation.ages.child,
                                      },
                                    }),
                                    _vm._v(")\n                    "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _setup.occupation.ages.infant.till
                        ? _c(
                            _setup.MyCheckbox,
                            {
                              staticClass: "room-modal-order__checkbox",
                              attrs: { choosed: _setup.infant_str },
                              on: { input: _setup.set_infant },
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    title: _setup.occupation.ages.infant.src,
                                  },
                                },
                                [
                                  _vm._v("Добавить в каюту ребенка "),
                                  _c(_setup.SinceTill, {
                                    attrs: {
                                      agesLine: _setup.occupation.ages.infant,
                                    },
                                  }),
                                  _vm._v(" без места и питания"),
                                ],
                                1
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "room-modal-order__checkbox" },
                            [
                              _vm._v(
                                "\n                    В данном круизе бронирование детей возможно "
                              ),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    title: _setup.occupation.ages.infant.src,
                                  },
                                },
                                [_vm._v("только с местом")]
                              ),
                            ]
                          ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "room-modal-order__total room-modal-order__total--forone",
                },
                [
                  _vm._v(
                    "\n                Базовая стоимость основого места\n                "
                  ),
                  _c(_setup.PriceCurrencyV, {
                    attrs: {
                      price: _setup.props.CabinSet.baseprice,
                      sum: false,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _setup.precalc.calc.wait
                ? _c(
                    "div",
                    [
                      _c(_setup.Loader, {
                        staticClass: "room-modal-order__loader",
                      }),
                    ],
                    1
                  )
                : _setup.precalc.calc &&
                  _setup.precalc.calc.ok &&
                  _setup.precalc.calc.acc
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "room-modal-order__total" },
                      [
                        _vm._v(
                          "\n                    Итого: \n                    "
                        ),
                        _c(_setup.PriceCurrencyV, {
                          attrs: { price: _setup.precalc.first, sum: true },
                        }),
                      ],
                      1
                    ),
                  ])
                : _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _setup.precalc.calc.ok && !_setup.precalc.calc.acc
                            ? `Нельзя добавить каюту: ${_setup.precalc.calc.acc_message}`
                            : ""
                        ) +
                        "\n                " +
                        _vm._s(
                          !_setup.precalc.calc.ok
                            ? `Не получается добавить каюту, возможно позже: ${_setup.precalc.calc.error}`
                            : ""
                        ) +
                        "\n            "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "room-modal-order__footer room-modal-footer" },
                [
                  _setup.isBooked() || _setup.occupation.mayBook
                    ? [
                        _c("div", { staticClass: "room-modal-footer__info" }, [
                          _c(
                            "div",
                            { staticClass: "room-modal-footer__info-text" },
                            [
                              _vm._v(
                                "Конечная стоимость с учетом всех скидок будет рассчитана после бронирования"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _setup.isBooked()
                            ? _c(
                                "button",
                                {
                                  staticClass: "room-modal-footer__remove",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _setup.remove_click.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Удалить\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "room-modal-footer__action" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn--bluefigma",
                                attrs: {
                                  disabled: _setup.button_book_disabled(),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _setup.book_click.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                           " +
                                    _vm._s(_setup.button_book_text()) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("div", { staticClass: "room-modal-footer__stop" }, [
                          _vm._v(
                            "\n                        На этом круизе нельзя бронировать более чем " +
                              _vm._s(
                                _setup.kayut(_setup.occupation.max_cabins)
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ],
                ],
                2
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }